'use client';

// Re-export all project page section components from their individual files
// This maintains backward compatibility with existing imports

export {
  PANEL_HEIGHT,
  CARD_ASPECT_RATIO,
  SectionHeader,
  SectionPanel,
  ScrollableCarousel,
  CompactSection,
  NavigationCircle,
  SectionChevron,
  RequiredIndicator,
  ContextPreview,
  ContextCount,
  type SectionAction,
} from './section-components';

export { OnboardingEmptyState } from './OnboardingEmptyState';
export { ProjectHeroSection } from './ProjectHeroSection';
export { ProjectGoalsSection } from './ProjectGoalsSection';
export { ProjectAnglesSection } from './ProjectAnglesSection';
export { ProjectReferencesSection } from './ProjectReferencesSection';
export { ProjectConceptsSection } from './ProjectConceptsSection';
export { ProjectEstimatesSection } from './ProjectEstimatesSection';
export { ProjectAlbumsSection } from './ProjectAlbumsSection';
export { ProjectEmptyState } from './ProjectEmptyState';
